import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const MediaSection = ({ media }) => {
    const { t } = useTranslation();

    return (
        <div>
            <h2 className={'text-lg text-gray-700 uppercase mb-1 mt-2'}>{t('general.labels.media_documents')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-2 flex items-center">
                    <label className="block text-gray-700 mr-2">{t('general.fields.diploma')}</label>
                    {media.diploma ? (
                        <a href={media.diploma.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 flex items-center">
                            {media.diploma.fileName}
                            <FontAwesomeIcon icon={faDownload} className="ml-2" />
                        </a>
                    ) : (
                        <p>{t('general.messages.no_diploma')}</p>
                    )}
                </div>
                <div className="mb-2 flex items-center">
                    <label className="block text-gray-700 mr-2">{t('general.fields.visa')}</label>
                    {media.visa ? (
                        <a href={media.visa.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 flex items-center">
                            {media.visa.fileName}
                            <FontAwesomeIcon icon={faDownload} className="ml-2" />
                        </a>
                    ) : (
                        <p>{t('general.messages.no_visa')}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MediaSection;
